import axios from '../../axios-config'
/**
 * POST
 * /discover/api/v1/export
 * doExport
 */
export const doExport = (params, data) => {
  return axios.post('/discover/api/v1/export', data, { params })
}
